import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
//import i18next from "../../i18n/i18n.config";

import { AddinsData } from "../../utils/AddinsData";
// import { Tab } from "../../pages/tab"; // TODO: Remove tab
import { Filter } from "./Filter";
import { FilterUtils, useIsDesktop } from "./FilterUtils";
import { LibraryUtils } from "../LibraryContainer/LibraryUtils";
import { AddinLib } from "../LibraryContainer/AddinLib";
import { ContactTrigger } from "../ContactTrigger/ContactTrigger";


let hash_message = {
    "rdkfilter": window.location.hash,
    "rdkinfo": window.location.search,
};
window.addEventListener("message", (event) => {
    if (!window.Settings.LOCAL_BUILD) {
        if(event.data.hasOwnProperty("rdkfilter")) {
            hash_message = {
                "rdkfilter": event.data.rdkfilter,
                "rdkinfo": event.data.rdkinfo
            }
        }
    }
});

// Init on message for url filters
let tickApplyFilter = null;

// Default applications, publishers, categories
let publisherFilter: stringBoolMap = {};
Object.keys(AddinsData.ListAllPublisher).forEach(publisher => {
    publisherFilter[publisher] = false
});

let categoryFilter: stringBoolMap = {};
Object.keys(AddinsData.ListAllCategories).forEach(category => {
    categoryFilter[category] = false
});

let priceFilter: stringBoolMap = {
    'Free': false,
    'Paid': false,
}

// Flag to hide tab
const hideTab = window.location.search.includes("HideTab");

export const AddinFilter = () => {
    const { t, i18n } = useTranslation();

    // Init state
    const [init, setInit] = React.useState(true);

    // Filter States
    // const [applications, setApplications] = React.useState()
    const [publishers, setPublishers] = React.useState(publisherFilter);
    const [categories, setCategories] = React.useState(categoryFilter);
    const [price, setPrice] = React.useState(priceFilter);

    const [sortFilteredAddins, setSortFilteredAddins] = React.useState(AddinsData.DATA_ALL);

    // Filter helper states
    const [filterType, setFilterType] = React.useState("instant");
    const [noResultMessage, setNoResultMessage] = React.useState("");

    // Helper variables
    let filteredAddinsCounts = FilterUtils.countCheckboxParameters("addin", sortFilteredAddins);

    const parameters = {
        // "applications": applications,
        "publishers": publishers,
        "categories": categories,
        "price": price,
    };

    const setupFilter = (url_data: any) => {
        const default_filter_map = {
            // "application": applicationFilter,
            "publisher": publisherFilter,
            "category": categoryFilter,
            "price": priceFilter,
        };
        const filter_set_map = {
            // "appliaction": setApplications,
            "publisher": setPublishers,
            "category": setCategories,
            "price": setPrice,
        }

        FilterUtils.extractUrlQueryOnMessage("addin", url_data["rdkfilter"]);
        //console.log("extracted params", FilterUtils.extracted_params);

        // Apply filters
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(FilterUtils.extracted_params.hasOwnProperty("name"))
            search_input.value = FilterUtils.extracted_params['name'];

        //console.log(FilterUtils.extracted_params)
        Object.keys(FilterUtils.extracted_params).map((key) => {
            if(key != "name") {
                editFilterFromUrl(
                    FilterUtils.extracted_params[key],
                    default_filter_map[key],
                    filter_set_map[key]
                );
            }
        });

        // Change init
        setInit(false);
        setFilterType("instant");
    };

    // onmessage for production version pairs with php
    onmessage = (event: any) => {
        if(event.data.hasOwnProperty("rdkfilter")) {
            setupFilter({
                "rdkfilter": event.data.rdkfilter,
                "rdkinfo": event.data.rdkinfo
            });
        }
    }

    const editFilterFromUrl = (
        extracted_param: any, 
        default_filter: any,
        set_filter: any,
    ) => {
        // console.log("extracted sent", extracted_param);
        // console.log("default filter", default_filter);
        // console.log("set filter", set_filter)


        if(Array.isArray(default_filter)) {
            const [min, max] = [
                parseFloat(extracted_param[0]),
                parseFloat(extracted_param[1])
            ];
            
            set_filter([
                min < default_filter[0] ? default_filter[0] : min,
                max > default_filter[1] ? default_filter[1] : max
            ]);
            setFilterType("instant");

        } else {
            let cloned_filter = structuredClone(default_filter);
            Object.keys(cloned_filter).map((entry) => {
                if(extracted_param.includes(entry.toLowerCase()))
                    cloned_filter[entry] = true;
            });

            set_filter(cloned_filter);
            setFilterType("instant");
        }
    }

    // filter methods
    const applyFilters = () => {
        tickApplyFilter = null;

        let filtered_list: any = AddinsData.DATA_ALL; 
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(search_input.value.length > 0)
            filtered_list = LibraryUtils.searchWithItemsList("addin", filtered_list);

        for(const key in parameters) {
            let temp = FilterUtils.applyFiltersToList("addin", key, parameters[key], filtered_list);

            if(Object.keys(temp).length > 0)
                filtered_list = temp;

            // If parameter is of type range then take the result even when it's empty
            if([
                "mechanism_counts", 
                "tool_counts", 
                "object_counts",
            ].includes(key) && FilterUtils.rangeFilterChangedFromDefault(key, parameters[key]))
                filtered_list = temp;
        }

        filteredAddinsCounts = FilterUtils.countCheckboxParameters("addin", filtered_list);
        //console.log('count', filteredAddinsCounts)

        if(filtered_list.length == 0) {
            setNoResultMessage("No robots match your filter.");
        } else {
            setNoResultMessage("");
        }

        applyFiltersToUrl();
        setSortFilteredAddins(filtered_list);

        if (init) setFilterType("instant");
        else setFilterType("");
    };

    const applyFiltersSchedule = () => {
        if(tickApplyFilter != null) {
            clearTimeout(tickApplyFilter);
        };
        tickApplyFilter = setTimeout(applyFilters, 100);
    };

    const applyFiltersToUrl = () => {
        let hash_str = "";
        let query_symbol = "#filter?";
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        const filter_strings = {
            // "application": applications,
            "publisher": publishers,
            "category": categories,
            "price": price,
        }

        // name
        if(search_input.value.length > 0) {
            hash_str += query_symbol + "name=" + search_input.value.trim().toLowerCase().split(" ").join("+");
            query_symbol = "&";
        }

        // checkbox and slider
        Object.keys(filter_strings).map((string) => {
            let temp_hash = editUrlFilter(
                string, 
                filter_strings[string], 
                query_symbol
            );

            if(temp_hash != undefined) {
                hash_str += temp_hash;
                query_symbol = "&";
            }
        });

        // Only change hash when not init because
        // on init the hash is empty and it will reset
        // the hash to empty, this will make the saved urls
        // with filters not working properly
        if(!init) {
            window.location.hash = hash_str;
            window.parent.postMessage( { "hash": window.location.hash } );
        }
    };

    const editUrlFilter = (
        filter_string: string, 
        filter: any,
        query_symbol: string,
    ) => {
        // if(Array.isArray(filter)) {
        //     let default_ranges = {
        //         "mechanism_count": [StationData.robotMin, StationData.robotMax],
        //         "tool_count": [StationData.toolsMin, StationData.toolsMax],
        //         "object_count": [StationData.objectsMin, StationData.objectsMax],
        //     }

        //     if (
        //         filter[0] > default_ranges[filter_string][0] ||
        //         filter[1] < default_ranges[filter_string][1]
        //     )
        //         return query_symbol + filter_string + "=" + filter[0] + "-" + filter[1];

        // } else {
            let checked_values = [];
            Object.keys(filter).map((entry) => {
                if (filter[entry]) {
                    let temp_value = entry.trim().toLowerCase().split(" ").join("-");
                    if(temp_value == "ext.-axis") temp_value = "ext.axis"
                    checked_values.push(temp_value);
                }
            });
            if (checked_values.length > 0) {
                return query_symbol + filter_string + "=" + checked_values.join("+");
            }
        // }
    };

    const clearFilters = () => {
        // setApplications(applicationFilter);
        setPublishers(publisherFilter);
        setCategories(categoryFilter);
        setPrice(priceFilter);

        setFilterType("instant");
    };

    const clearSearchParameters = () => {
        (document.getElementById("search-input") as HTMLInputElement).value = "";
       
        applyFilters();
        setFilterType("instant");
    };

    // Application filter new
    // const handleInputChangeApplicationFilter = (e: React.MouseEvent<HTMLInputElement>) => {
    //     let new_application_filter = structuredClone(applications);
    //     new_application_filter[e.currentTarget.value] = e.currentTarget.checked;

    //     setApplications(new_application_filter);
    //     setFilterType("instant");
    // };

    // Publisher filter
    const handleInputChangePublisherFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_publisher_filter = structuredClone(publishers);
        new_publisher_filter[e.currentTarget.value] = e.currentTarget.checked;

        setPublishers(new_publisher_filter);
        setFilterType("instant");
    };

    // Category filter
    const handleInputChangeCategoryFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_category_filter = structuredClone(categories);
        new_category_filter[e.currentTarget.value] = e.currentTarget.checked;

        setCategories(new_category_filter);
        setFilterType("instant");
    };
    
    React.useEffect(() => {
        if(filterType == "delay")
            applyFiltersSchedule()

        else if(filterType == "instant")
            applyFilters();
    });

    // Price filter
    const handleInputChangePriceFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_price_filter = structuredClone(price);
        new_price_filter[e.currentTarget.value] = e.currentTarget.checked;

        setPrice(new_price_filter);
        setFilterType("instant");
    };
    
    // Retrieve url filters
    // onload for local and direct production version
    React.useEffect(() => {
        if (init) {
            setupFilter(hash_message);
            setInit(false);
        }
    }, []);

    React.useEffect(() => {
        if(filterType == "delay")
            applyFiltersSchedule()

        else if(filterType == "instant")
            applyFilters();
    });

    const isSticky = useIsDesktop();

    return (
        <>
            {/* <div className="title sticky-top">
                {!hideTab && (
                    <Tab library={"addin"} />
                )}
            </div> */}

            <div className="main-container container-fluid">
                <div className="row">
                    <div className="col col-12 col-sm-12 col-lg-3">
                        <div
                            className={`filter-form ${isSticky ? "sticky-top" : ""}`}
                            style={{ 
                                top: isSticky ? (window.Settings.LOCAL_BUILD ? "8rem" : "12.5rem") : undefined,
                                backgroundColor: "rgb(240, 240, 240)" 
                            }}
                        >
                            {/* {!hideTab && (
                                <Tab library={"addin"} />
                            )} */}
                            
                            <div id="search-row">
                                <form id="search-bar">
                                    <input 
                                        id="search-input"
                                        type="text"
                                        placeholder={t('library-headers.search-input')}
                                    />
                                    <div id="search-bar-action-btns">
                                        <button
                                            id="search-button"
                                            onClick={(e: React.MouseEvent) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                applyFilters();
                                            }}
                                        >
                                            <img
                                                width="auto"
                                                height="18rem"
                                                alt="Search"
                                                src={window.Paths.ADDIN_LIB_ASSETS_CDN + "magnifier.png"}
                                            />
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <div className="section-top">
                                <a
                                    className="btn center-block"
                                    onClick={clearFilters}
                                >
                                    {t('library-overlays.clearFiltersBtn')}
                                </a>
                                <a
                                    className="btn center-block"
                                    style={{ marginLeft: ".5rem" }}
                                    onClick={clearSearchParameters}
                                >
                                    {t('library-overlays.clearSearchBtn')}
                                </a>
                                <a
                                    className="btn center-block"
                                    style={{ marginLeft: ".5rem" }}
                                    onClick={(e: React.MouseEvent) => {
                                        clearFilters();
                                        clearSearchParameters();
                                    }}
                                >
                                    {t('library-overlays.clearAllBtn')}
                                </a>
                            </div>

                            <div className="filters">
                                {/* <Filter 
                                    type = "addins"
                                    title = "station.attributes.application"
                                    data = {{}}
                                    counts = {filteredAddinsCounts}
                                    handler = {handleInputChangeApplicationFilter}
                                    first = {true}
                                /> */}

                                <Filter 
                                    type = "publishers"
                                    title = "filters-addins.publisher"
                                    data = {publishers}
                                    counts = {filteredAddinsCounts}
                                    handler = {handleInputChangePublisherFilter}
                                    first = {true}
                                />

                                <Filter 
                                    type = "categories"
                                    title = "filters-addins.category"
                                    data = {categories}
                                    counts = {filteredAddinsCounts}
                                    handler = {handleInputChangeCategoryFilter}
                                    first = {false}
                                />

                                <Filter 
                                    type = "price"
                                    title = "Price"
                                    data = {price}
                                    counts = {filteredAddinsCounts}
                                    handler = {handleInputChangePriceFilter}
                                    first = {false}
                                />
                            </div>

                            <ContactTrigger type={"link"} />
                        </div>
                    </div>

                    <div className="col col-12 col-sm-12 col-lg-9">
                        <AddinLib 
                            noResultMessage = {noResultMessage}
                            sortFilteredAddins = {sortFilteredAddins}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}